import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import {
  addDegree,
  getDegreeById,
  updateDegree,
} from "../../../services/DegreeService";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";

export const foodOptions = [
  { value: "food", label: "Food", color: "#FF8B00" },
  { value: "fashion", label: "Fashion", color: "#FFC400" },
  { value: "lifestyle", label: "Lifestyle", color: "#36B37E" },
];

const initialState = true;
const reducer = (state, action) => {
  switch (action.type) {
    case "collpase0":
      return { ...state, collpase0: !state.collpase0 };
    case "collpase1":
      return { ...state, collpase1: !state.collpase1 };
    case "collpase2":
      return { ...state, collpase2: !state.collpase2 };
    case "collpase3":
      return { ...state, collpase3: !state.collpase3 };
    case "collpase4":
      return { ...state, collpase4: !state.collpase4 };
    case "collpase5":
      return { ...state, collpase5: !state.collpase5 };
    case "collpase6":
      return { ...state, collpase6: !state.collpase6 };
    case "collpase7":
      return { ...state, collpase7: !state.collpase7 };
    case "collpase8":
      return { ...state, collpase8: !state.collpase8 };
    case "collpase9":
      return { ...state, collpase9: !state.collpase9 };
    case "collpase10":
      return { ...state, collpase10: !state.collpase10 };
    case "collpase11":
      return { ...state, collpase11: !state.collpase11 };
    case "collpase12":
      return { ...state, collpase12: !state.collpase12 };
    case "collpase13":
      return { ...state, collpase13: !state.collpase13 };
    case "section0":
      return { ...state, section0: !state.section0 };
    case "section1":
      return { ...state, section1: !state.section1 };
    case "section2":
      return { ...state, section2: !state.section2 };
    case "section3":
      return { ...state, section3: !state.section3 };
    case "section4":
      return { ...state, section4: !state.section4 };
    case "section5":
      return { ...state, section5: !state.section5 };
    case "section6":
      return { ...state, section6: !state.section6 };
    case "section7":
      return { ...state, section7: !state.section7 };
    case "section8":
      return { ...state, section8: !state.section8 };
    case "section9":
      return { ...state, section9: !state.section9 };
    default:
      return state;
  }
};

const AddDegree = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [status, setStatus] = useState("draft");
  const [loading, setLoading] = useState(false);
  const [degreeName, setDegreeName] = useState("");
  const hasFetched = useRef(false);
  const { id } = useParams();
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchDegree = async () => {
        try {
          setLoading(true);
          const response = await getDegreeById(id);
          const degree = response?.data;
          setDegreeName(degree?.data?.title);
        } catch (err) {
          console.error("Error fetching degree:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchDegree();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!degreeName.trim()) {
      newErrors.degreeName = "Title is required";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) {
        return;
      }
      const degreeData = { title: degreeName };

      setLoading(true);

      if (id) {
        // --- UPDATE EXISTING COUNTRY ---
        await updateDegree(id, degreeData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Degree details updated successfully",
        });
        navigate("/degree", {
          state: {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          },
        });
      } else {
        // --- CREATE NEW COUNTRY ---
        const response = await addDegree(degreeData);
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Degree added successfully",
          });
          navigate("/degree", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          });
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    } finally {
      // hide loader
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Degree" : "Add Degree"}`}
        motherMenu="Degree"
        activeMenuLink={`${id ? `edit-degree/${id}` : "add-degree"}`}
        motherMenuLink={"degree"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/degree", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Degree List</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        className="form-control w-full"
                        placeholder="Title"
                        value={degreeName} // bind value
                        onChange={(e) => setDegreeName(e.target.value)} // update state
                      />
                      {errors?.degreeName && (
                        <div className="text-danger mb-3 mt-1">
                          {errors.degreeName}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              <hr style={{ margin: "0px" }} className="mx-2" />
              <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    navigate("/degree", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  Back
                </Button>

                {/* Save / Update Button */}
                <Button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSave}
                >
                  {id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDegree;
